import { render, staticRenderFns } from "./EventTutorial.vue?vue&type=template&id=d234ce12&"
import script from "./EventTutorial.vue?vue&type=script&lang=js&"
export * from "./EventTutorial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports